/* eslint-disable compat/compat */
import React from 'react';
import classNames from 'classnames';
import { CloseCircleFilled24Icon } from '@royalaholddelhaize/design-system-pantry-web/assets/icons/ah';
import { createTestHook } from '../../../../utils/create-test-hook';
import css from './image-preview.module.scss';

type ImageWithUrl = {
    imageId: string;
    url: string;
};

const isFeedbackImageWithUrl = (
    image: File | ImageWithUrl,
): image is ImageWithUrl => {
    return 'url' in image;
};

type ImagePreviewProps = {
    images: File[] | ImageWithUrl[];
    onDelete?: (index: number) => void;
    enableDelete: boolean;
    variant?: 'fluid' | 'fixed';
};
export const ImagePreview: React.FC<ImagePreviewProps> = ({
    images,
    onDelete,
    enableDelete,
    variant = 'fluid',
}) => {
    if (images.length === 0) {
        return null;
    }

    const isFluid = variant === 'fluid';

    return (
        <div className={css.images}>
            {images.map((image, index) => {
                const url = isFeedbackImageWithUrl(image)
                    ? image.url
                    : URL.createObjectURL(image);
                return (
                    <div
                        className={classNames(css.imageContainer, {
                            [css.fixed]: !isFluid,
                        })}
                        /* eslint-disable-next-line react/no-array-index-key */
                        key={`${index}`}
                        {...createTestHook('file-upload-image-preview')}
                    >
                        <img
                            className={classNames(css.image, {
                                [css.fluid]: isFluid,
                                [css.fixed]: !isFluid,
                            })}
                            alt="voorbeeld afbeelding"
                            src={url}
                        />
                        {enableDelete && (
                            <button
                                type="button"
                                tabIndex={0}
                                {...createTestHook('image-preview-delete')}
                                onClick={() => {
                                    onDelete && onDelete(index);
                                }}
                                className={css.deleteButton}
                            >
                                <CloseCircleFilled24Icon
                                    className={css.deleteIcon}
                                />
                            </button>
                        )}
                    </div>
                );
            })}
        </div>
    );
};
